import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Card, Typography, message, Tag } from 'antd';
import { GetJutgeUsuariIdJavamonsNota } from "../../../../dao/jutge/GetJutgeUsuariIdJavamonsNota";
import { getJavamonImage } from "../../../../dao/jutge/GetJavamonConfig";

const { Text } = Typography;

interface Props {
    visible: boolean;
    onClose: () => void;
    onSelect: (idJavamon: string) => void;
    userId: string;
}

const SelectJavamonNotaModal: React.FC<Props> = ({ visible, onClose, onSelect, userId }) => {
    const [javamons, setJavamons] = useState<any[]>([]);

    useEffect(() => {
        if (visible) {
            GetJutgeUsuariIdJavamonsNota(userId).then(setJavamons);
        }
    }, [visible, userId]);

    const javamonImage = (jm: any) => {
        return getJavamonImage(jm);
    }

    return (
        <Modal
            title="Selecciona un Javamon de NOTA (+0.5 pts)"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
        >
            <Row gutter={[16, 16]}>
                {javamons.map(j => {
                    const charges = 5 - (j.used || 0);
                    return (
                        <Col span={8} key={j.id}>
                            <Card
                                hoverable
                                onClick={() => onSelect(j.id)}
                                cover={
                                    <img
                                        alt={j.nom}
                                        src={javamonImage(j)}
                                        style={{ height: 100, objectFit: 'contain', padding: 10 }}
                                    />
                                }
                            >
                                <Card.Meta
                                    title={<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ fontSize: 12 }}>{j.nom}</span>
                                        <Tag color={charges > 0 ? 'gold' : 'red'}>{charges}/5</Tag>
                                    </div>}
                                    description={<span style={{ fontSize: 10 }}>{j.descr}</span>}
                                />
                            </Card>
                        </Col>
                    );
                })}
                {javamons.length === 0 && <Text>No tienes Javamons de NOTA disponibles con cargas.</Text>}
            </Row>
        </Modal>
    );
};

export default SelectJavamonNotaModal;
